import React, { useCallback, useEffect, useRef, useState } from "react";

const ClickOutside = ({ isOpen = true, onClickOutside, children, className = "weidget-window-active" }) => {
  const ref = useRef();

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isOpen && ref.current && !ref.current.contains(e.target)) {
        onClickOutside();
      }
    };

    // Add a small delay to prevent immediate triggering
    const timeoutId = setTimeout(() => {
      document.addEventListener("click", checkIfClickedOutside);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("click", checkIfClickedOutside);
    };
  }, [isOpen, onClickOutside]); // Add dependencies

  return (
    <div className={`${className || ''} `} ref={ref}>
      {children}
    </div>
  );
};


export function useFocusOutside() {
  const [isFocused, setIsFocused] = useState(false);
  const ref = useRef();

  const handleFocusIn = useCallback((event) => {
    if (ref.current && ref.current.contains(event.target)) {
      setIsFocused(true);
    }
  }, []);

  const handleFocusOut = useCallback((event) => {
    if (ref.current && !ref.current.contains(event.relatedTarget)) {
      setIsFocused(false);
    }
  }, []);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    element.addEventListener('focusin', handleFocusIn);
    element.addEventListener('focusout', handleFocusOut);

    return () => {
      element.removeEventListener('focusin', handleFocusIn);
      element.removeEventListener('focusout', handleFocusOut);
    };
  }, [handleFocusIn, handleFocusOut]);

  return { ref, isFocused };
}
export default ClickOutside;